var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"headline",attrs:{"id":"normal-payment"}},[_vm._v(" Add Payment "),_c('v-spacer'),_c('v-btn',{attrs:{"id":"close-add-payment","icon":"","color":"primary"},on:{"click":_vm.closeForm}},[_c('v-icon',[_vm._v("close")])],1)],1),_c('v-divider'),_c('StripeAddPayment')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }